import { QueryClient } from 'react-query'

/**
 * react-query v3 defaults to `retry: 3` with exponential backoff (1s + 2s + 4s),
 * so a failing request takes ~7 seconds and fires four times before an error
 * state renders. That is correct for real users on a flaky network and actively
 * hostile to the e2e suite, where every stubbed 500 would turn into a timeout
 * race and quadruple the request count each `cy.wait` has to reason about.
 *
 * VITE_ENV is only 'e2e' under `vite --mode e2e` (see .env.e2e), and
 * `vite build --mode e2e` is refused outright in vite.config.ts, so the override
 * can never reach a real bundle. Keep it that way — see the guardrails section
 * of thirdline/CLAUDE.md.
 */
export const buildQueryClient = (env) =>
  new QueryClient(
    env === 'e2e' ? { defaultOptions: { queries: { retry: false } } } : undefined
  )
